/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography, breakpoints } from '@coursera/cds-core';

type Props = {
  title: string;
  description: React.ReactNode;
  desktopImage: React.ReactNode;
  mobileImage: React.ReactNode;
};

const styles = {
  mobileCertificate: () => css`
    display: none;
    margin-bottom: calc(var(--cds-spacing-400) * -1);
    ${breakpoints.down('sm')} {
      display: flex;
      justify-content: center;
    }
  `,
  imageContainerMobile: css`
    height: 165px;
    width: 259px;
  `,
  moduleContent: () => css`
    border: 2px solid var(--cds-color-grey-50);
    border-radius: 8px;
  `,
  leftColumnContent: () => css`
    padding: var(--cds-spacing-400);
    ${breakpoints.down('sm')} {
      padding: var(--cds-spacing-600) var(--cds-spacing-400) var(--cds-spacing-400) var(--cds-spacing-400);
    }
    ${breakpoints.down('xs')} {
      padding: var(--cds-spacing-600) var(--cds-spacing-200) var(--cds-spacing-200) var(--cds-spacing-200);
    }
  `,
  title: () => css`
    margin-bottom: var(--cds-spacing-200);
    ${breakpoints.down('sm')} {
      margin-bottom: var(--cds-spacing-100);
    }
  `,
  certImageContainerDesktop: () => css`
    min-height: 168px;
    position: relative;
    ${breakpoints.down('sm')} {
      display: none;
    }
  `,
  backgroundBlobContainer: css`
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 96%;
    overflow: hidden;
  `,
  backgroundBlob: () => css`
    position: absolute;
    height: 200%;
    width: 200%;
    background-color: var(--cds-color-blue-50);
    opacity: 0.5;
    clip-path: ellipse(30% 100% at 30% 10%);
  `,
};

const CertificateAndBenefitsText = ({ title, description, desktopImage, mobileImage }: Props) => {
  return (
    <Grid item xs={12}>
      <div css={styles.mobileCertificate}>
        <div css={styles.imageContainerMobile}>{mobileImage}</div>
      </div>
      <div css={styles.moduleContent}>
        <Grid container>
          <Grid item xs={12} md={7}>
            <div css={styles.leftColumnContent}>
              <Typography variant="h1semibold" component="h2" css={styles.title}>
                {title}
              </Typography>
              {description}
            </div>
          </Grid>
          <Grid item xs={12} md={5} css={styles.certImageContainerDesktop}>
            <div css={styles.backgroundBlobContainer}>
              <div css={styles.backgroundBlob} />
            </div>
            {desktopImage}
          </Grid>
        </Grid>
      </div>
    </Grid>
  );
};

export default CertificateAndBenefitsText;
